import React, { useState, useEffect } from 'react';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../../utils/Common';
import Verifiers from '../../../../../utils/Verifiers.jsx';

const EditarVariedad = (p) => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [data, setdata] = useState(p.data ?? { "id": null, "nombre": "", "por_plan": 0 });
    let fields = [{ name: 'nombre', label: 'NOMBRE DE LA VARIEDAD', help: "", type: "text", required: true }, { name: 'por_plan', label: 'POR PLAN', help: "Valor opcional", type: "text", required: false }];

    const actualizar = async () => {
        if (Verifiers.text_normalice(data.nombre) == "") {
            activeDialog(setdialog, 'Agrege un nombre común para la variedad', 'error', 'Error');
            return;
        }
        let dataSend = { id: data.id, nombre: data.nombre, por_plan: data.por_plan };

        let resp = await Post('catalogos/flores/variedades/update', dataSend, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        p.close(resp.data);

    }

    const eliminar = async () => {
        let resp = await Post('catalogos/flores/variedades/delete', { id: data.id }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        p.close(resp.data);
    }

    const eliminarConfimacion = () => {
        setdialog({
            tipo: "error",
            show: true,
            title: "CONFIRME PARA CONTINUAR",
            body: "¿Realmente desea eliminar esta variedad?",
            respYes: "Si, eliminar",
            respNot: "Cancelar",
            funct: (resp) => { if (resp) eliminar(); setdialog({ show: false }) },
            size: 'm'
        });
    }
    return (
        <div className='vw-100 vh-100 blur-xl bg-white4' style={{ position: "fixed", top: 0, left: 0, zIndex: 999 }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 text-end mt-4' style={{ position: "sticky", left: 0, top: 0, zIndex: 15 }}>
                    <button className='btn btn-danger shadow me-2 round-xl border border-2 border-dark scale-continue-05' onClick={() => p.close(false)}>Cerrar</button>
                </div>
                <div className='bw-300 mt-2 bg-white3 border shadow round-xxl text-center text-300 h4'>{data.id ? 'Editar variedad' : "Nueva variedad"}</div>
                <div className='w-100 m-0 p-0'></div>
                <div className='bw-700 round-m shadow-multi bg-white p-3'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {
                            fields.map((field, i) =>
                                <div key={field.name} className='form-group bw-300 m-1 mt-3'>
                                    <label className='text-bold w-100 text-start ps-2'>
                                        {field.label}
                                        {field.help && <span className='text-xs text-500 text-blue4 ms-2'>{field.help}</span>}
                                    </label>
                                    <input type={field.type}
                                        className='form-control shadow border'
                                        value={data[field.name]}
                                        onChange={(event) => setdata({ ...data, [field.name]: event.target.value })}
                                        required={field.required} />
                                </div>
                            )
                        }
                        <div className='w-100 mt-3'></div>
                        {data.id && <div className='bw-200 m-0 p-0'>
                            <button className='btn btn-danger shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={eliminarConfimacion}
                            >Eliminar variedad</button>
                        </div>}
                        <div className='w-100'></div>
                        <div className='bw-400 mt-4 mb-3 ms-0 me-0'>
                            <button className='btn btn-warning shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={actualizar}
                            >{data.id ? 'Guardar cambios' : "Agregar"}</button>
                        </div>

                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default EditarVariedad;